module.exports = __webpack_public_path__ + "img/chairs-sprite-2x.0c6c4ace.png";